import { Button, TableProps } from 'antd';
import { FolderOutlined } from '@ant-design/icons';
import { FileIconComponent } from '../icons';
import { AppConstants } from '@/utils/constants';

export const compareText = (a: unknown, b: unknown): number =>
  String(a ?? '')
    .toLowerCase()
    .localeCompare(String(b ?? '').toLowerCase());

export const Documentcolumn = (
  t: any,
  onExpand: any,
  isAdmin: boolean = false,
  momentWithTimezone: (inputTime?: any) => string,
  setCurrentNode?: (node: any) => void,
): TableProps<any>['columns'] => {
  return [
    {
      title: t('home.documents.table.name'),
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      width: '50%',
      sorter: (a: any, b: any) => compareText(a.name, b.name),
      render: (text, record) => {
        const status = record?.status || record?.extras?.status || '';
        const isProcessing =
          status === 'processing' ||
          (record.isLeaf &&
            (record.processed === false || record.processed === undefined));
        const isGreyedOut = isProcessing;
        return record.isLeaf ? (
          FileIconComponent(text, record?.path, 16, isGreyedOut)
        ) : (
          <Button
            type={'link'}
            onClick={() => {
              if (!record.isLeaf) {
                onExpand(record);
              }
            }}
            title={text}
            style={isGreyedOut ? { color: '#999', opacity: 0.6 } : undefined}
          >
            <FolderOutlined width={40} />
            {text}
          </Button>
        );
      },
    },
    {
      title: t('home.documents.table.created'),
      dataIndex: 'created_at',
      key: 'created_at',
      sorter: (a: any, b: any) => {
        const dateA = a.created_at ? new Date(a.created_at).getTime() : 0;
        const dateB = b.created_at ? new Date(b.created_at).getTime() : 0;
        return dateA - dateB;
      },
      render: (value, record) => {
        const status = record?.status || record?.extras?.status || '';
        const isProcessing =
          status === 'processing' ||
          (record.isLeaf &&
            (record.processed === false || record.processed === undefined));
        return (
          <span
            style={isProcessing ? { color: '#999', opacity: 0.6 } : undefined}
          >
            {momentWithTimezone(value)}
          </span>
        );
      },
    },
    {
      title: t('home.documents.table.updated'),
      dataIndex: 'updated_at',
      key: 'updated_at',
      sorter: (a: any, b: any) => {
        const dateA = a.updated_at ? new Date(a.updated_at).getTime() : 0;
        const dateB = b.updated_at ? new Date(b.updated_at).getTime() : 0;
        return dateA - dateB;
      },
      render: (value, record) => {
        const status = record?.status || record?.extras?.status || '';
        const isProcessing =
          status === 'processing' ||
          (record.isLeaf &&
            (record.processed === false || record.processed === undefined));
        return (
          <span
            style={isProcessing ? { color: '#999', opacity: 0.6 } : undefined}
          >
            {momentWithTimezone(value)}
          </span>
        );
      },
    },
    {
      title: t('home.documents.table.owner'),
      dataIndex: 'created_by_name',
      key: 'created_by_name',
      sorter: (a: any, b: any) =>
        compareText(a.created_by_name, b.created_by_name),
      render: (value, record) => {
        const status = record?.status || record?.extras?.status || '';
        const isProcessing =
          status === 'processing' ||
          (record.isLeaf &&
            (record.processed === false || record.processed === undefined));
        const content =
          record?.default && !isAdmin ? AppConstants.SYSTEM_ADMIN_ORG : value;
        return (
          <span
            style={isProcessing ? { color: '#999', opacity: 0.6 } : undefined}
          >
            {content}
          </span>
        );
      },
    },
    {
      title: t('home.documents.table.updater'),
      dataIndex: 'updated_by',
      key: 'updated_by',
      sorter: (a: any, b: any) =>
        compareText(
          a.updated_by || a.created_by_name,
          b.updated_by || b.created_by_name,
        ),
      render: (value, record) => {
        if (record?.default && !isAdmin) return AppConstants.SYSTEM_ADMIN_ORG;
        if (!value) return record?.created_by_name;
        return value;
      },
    },
  ];
};
